import { Avatar } from "@chakra-ui/react";

type ProfileAvatarProps = React.ComponentProps<typeof Avatar> & {
  showPaidRing?: boolean;
};

export const ProfileAvatar = ({ showPaidRing, ...props }: ProfileAvatarProps) => {
  if (!showPaidRing) {
    return <Avatar {...props} />;
  }

  return (
    <div
      style={{
        padding: 2,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Avatar {...props} />
    </div>
  );
};
